import { useQuery } from "@tanstack/react-query";
import { validateMagicLinkTokenOptions } from "./keyOptions";
import { fetchValidateMagicLinkToken } from "./fetchValidateMagicLinkToken";

export function useValidateMagicLinkToken(token: string | null) {
    return useQuery({
        ...validateMagicLinkTokenOptions(token),
        queryFn: () => fetchValidateMagicLinkToken(token!),
        enabled: !!token,
    });
}
